<template>
  <div class="mb-10 px-6 md:px-0">
    <Swiper
      id="gallery-swiper"
      class="swiper-container w-full h-full max-h-[550px]"
      :modules="[SwiperPagination]"
      :slides-per-view="1"
      :space-between="15"
      :centered-slides-bounds="true"
      :center-insufficient-slides="true"
      :slides-offset-before="0"
      :pagination="{ el: '.swiper-pagination', clickable: true }"
      :breakpoints="{
        675: {
          slidesPerView: 2,
          spaceBetween: 0,
          slidesOffsetBefore: 1,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 0,
          slidesOffsetBefore: 0,
        },
      }"
    >
      <SwiperSlide v-for="(item, idx) in items" :key="`gallery-${idx}`" class="swiper-slide">
        <slot :item="item" />
      </SwiperSlide>
      <SwiperControls :current-index="currentIndex" @change="(index: number) => emit('slideChange', index)" />
    </Swiper>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script setup lang="ts">
import type { ProductImage } from '@robustastudio/e-commerce/common';

defineComponent({
  name: 'ProductPageViewSlider',
});

const props = defineProps({
  items: {
    type: Array as PropType<Array<ProductImage & { index: number }>>,
    required: true,
    default: () => [],
  },
  arrows: {
    type: Boolean,
    default: true,
  },
  activeImage: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['slideChange']);

const currentIndex = ref(0);
watch(
  () => props.activeImage,
  activeIndex => {
    currentIndex.value = activeIndex;
  },
);
</script>

<style lang="postcss" scoped>
.gallery-swiper-nav {
  width: 35px;
  height: 35px;

  &::after {
    content: none;
  }

  &.gallery-next {
    position: absolute;
    right: -20px;
    top: 50%;
    /* transform: scaleX(-1) translateY(-50%); */
  }

  &.gallery-prev {
    position: absolute;
    left: -20px;
    top: 50%;
    /* transform: translateY(-50%); */
  }

  &.swiper-button-disabled {
    opacity: 0.5;
  }

  @media (max-width: 767px) {
    display: none;
  }
}

.swiper-wrapper {
  @apply flex items-center;
}

.swiper-pagination {
  @apply lg:hidden;
}

.swiper-pagination-bullets {
  bottom: 10px;

  :deep(.swiper-pagination-bullet) {
    @apply bg-primary-1-40 w-1 h-1;
    transition: 0.5s all;

    &-active {
      @apply bg-primary-1-100 w-8;
      border-radius: 50px;
    }
  }
}
</style>
